module.exports = __webpack_public_path__ + "static/media/Jira.22e9d996.svg";